// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TabSwitch_wrapper__RltYH","root":"TabSwitch_root__1PJNV","tab":"TabSwitch_tab__2e50H","active":"TabSwitch_active__2qCi_","tabTitle":"TabSwitch_tabTitle__Az1CF"};